import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { transparentize } from '../../../helpers';

export const checkboxBase = css`
  min-width: 20px;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  print-color-adjust: exact;
  -webkit-print-color-adjust: exact;

  &.disabled {
    opacity: 0.25;
  }

  &::before {
    width: 28px;
    height: 28px;
    content: '';
    display: block;
    background: ${transparentize(0.7, theme.colors.primary50)};
    border-radius: 4px;
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    margin-top: -4px;
    margin-left: -4px;
    transform: scale(0);
    transform-origin: 50% 50%;
    transition: transform 200ms ease-out;
  }

  &::after {
    content: '';
    width: 100%;
    height: 100%;
    background: white;
    border: 1px solid ${theme.colors.neutral40};
    border-radius: 2px;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    transition: background 200ms ease-out, border-color 200ms ease-out;
  }

  & :focus-within::before {
    transform: scale(1);
  }

  & :focus-within::after {
    border-color: ${theme.colors.primary50};
  }

  &:not(.disabled).active {
    &::before {
      transform: scale(1);
    }

    &::after {
      border-color: ${theme.colors.primary50};
    }
  }

  &.checked {
    &::before {
      background: ${transparentize(0.7, theme.colors.primary50)};
    }

    &::after,
    & :focus-within::after {
      background: ${theme.colors.primary50};
      border-color: ${theme.colors.primary50};
    }
  }

  &:not(.disabled).error {
    &::before {
      background: ${transparentize(0.8, theme.colors.status.critical)};
    }

    &::after,
    & :focus-within::after {
      border-color: ${theme.colors.status.critical};
    }
  }
`;

export const stateIcon = css`
  transform: scale(0);
  transform-origin: 50% 50%;
  transition: transform 200ms ease-out;
  z-index: ${theme.zIndex.low};

  &.checked {
    transform: scale(1);
  }
`;
